import { createFileRoute, notFound } from "@tanstack/react-router";

import { QuestionnaireForm } from "@/components/questionnaire/questionnaire-form";
import { isIntakeStepId } from "@/lib/routes";

export const Route = createFileRoute("/intake/$stepId")({
  params: {
    parse: (raw) => {
      if (!isIntakeStepId(raw.stepId)) {
        throw notFound();
      }
      return { stepId: raw.stepId };
    },
  },
  component: IntakeStepPage,
});

function IntakeStepPage() {
  return <QuestionnaireForm />;
}
